import { ApolloError, QueryResult, gql, useLazyQuery } from '@apollo/client'
import { optionalEnrollmentId } from '@utils/optionalEnrollmentId'
import { ILesson } from '@dtos/Course'

const GET_PREVIOUS_AVAILABLE_LESSON_DATA = gql`
  query PreviousAvailableLessonData($currentLessonId: ID!, $enrollmentId: ID) {
    previousAvailableLesson(
      currentLessonId: $currentLessonId
      enrollmentId: $enrollmentId
    ) {
      id
      title
      courseContentId
      releaseAt
      releaseAfter
      lockAt
      lockAfter
      createdAt
      description
      activity {
        id
        examQuestionsCount
      }
      media {
        id
        type
        duration
        hostKey
        host
        fileExt
        text
        organizationUuid
      }
      coverImage {
        cdnFileUrl
      }
      extraMediaReleases {
        mediaId
        releaseAt
        releaseAfter
        lockAt
        lockAfter
      }
      extraMedias {
        id
        title
        type
        duration
        fileExt
        text
        hostKey
        host
        organizationUuid
        createdAt
      }
    }
  }
`

export const useGetPreviousAvailableLessonData = (
  currentLessonId: number,
  /** Ausente na visão do produtor: não existe matrícula. */
  enrollmentId?: number | string | null,
) => {
  const [getPreviousAvailableLessonData, { loading, error }] = useLazyQuery(
    GET_PREVIOUS_AVAILABLE_LESSON_DATA,
    {
      variables: {
        currentLessonId,
        enrollmentId: optionalEnrollmentId(enrollmentId),
      },
    },
  )

  return { getPreviousAvailableLessonData, loading, error } as {
    getPreviousAvailableLessonData: (
      currentLessonId: number,
      enrollmentId?: number | string | null,
    ) => Promise<QueryResult<{ previousAvailableLesson: ILesson }>>
    loading: boolean
    error: ApolloError
  }
}
